import styled from "styled-components";
import { Paragraph2, WrapperContainer } from "../../../components";
import { colors } from "../../../consts";
import { TableWrapper } from "../../../components/Table/styled";

export const SettingsTitle = styled(Paragraph2)`
  color: ${colors.RAISIN_70};
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.56px;
  margin: 24px 0 10px;
`;

export const LabelText = styled(Paragraph2)`
  font-size: 14px;
  line-height: 14px;
  font-weight: 500;

  color: ${colors.RAISIN_100};
`;

export const RoleTableWrapper = styled(WrapperContainer)`
  ${TableWrapper} {
    max-height: 58vh;
  }
`;
